let privacyPolicyZH = require('../privacyPolicy/privacyPolicy_zh')
let ENV = process.env

module.exports = {
  navbar: {
    language: '中文(简体)',
    myAccount: '我的账户',
    setting: '设置',
    signOut: '登出'
  },
  modal: {
    modalCancel: '取消',
    modalOk: '确认',
    modalChange: '变更'
  },
  country: {
    jp: '日本',
    cn: '中国'
  },
  status: {
    back: '返回',
    save: '保存',
    cancel: '取消',
    reSubmit: '重新申请',
    receipt: '受理',
    rateConfirm: '确定汇率',
    transferred: '执行转账',
    AC: '订单已申请',
    GU: '客户已放弃',
    WC: '正在确认货币到账',
    C: '管理员已取消',
    RA: '已确认货币到账',
    CR: '汇率确定',
    PC: '已完成订单'
  },
  orderInfoModal: {
    title: '确认',
    save: '将要保存以下信息，请确认无误。',
    statusAC: '将让客户重新提交申请资料及转账证明，请确认无误。',
    statusC: '取消订单之后将无法进行操作，请确认无误。',
    statusRA: '订单状态将修改为“已确认货币到账”，请确认无误。',
    statusCR: '兑换汇率和手续费将变更为以下内容，请确认无误。',
    statusPC: '请确认是否已完成所有相关手续。',
    copperRate: 'Copper Rate',
    rate: '兑换汇率',
    amount: '金额',
    charge: '手续费',
    operatorMessage: '客服消息',
    status: '申请状态',
    successTitle: '消息',
    successMessage: '订单状态已变更',
    successButton: '返回订单列表'

  },
  login: {
    welcome: '欢迎回来',
    explain: '请登录',
    email: '邮箱地址',
    emailPlaceholder: '请输入邮箱地址',
    emailRequired: '请输入邮箱地址',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    login: '登录',
    signUp: '点击注册',
    signUpText: '没有账号？',
    message: '邮箱或密码错误'
  },
  forgotPassword: {
    forgotPasswordText: '忘记密码？',
    modalTitle: '忘记密码',
    message: '消息',
    sendEmailSuccess: '已将邮件发送至您的邮箱，请查收邮件以完成密码重置。',
    passwordChangeSuccess: '密码已修改，请返回登录界面进行登录操作。'
  },
  top: {
    mytheme: '常用功能',
    myorder: '我的订单',
    mysettings: '设置',
    Previous: '上一页',
    Next: '下一页'
  },
  /**
     * orderHome
     */
  ordertop: {
    myhome: '主页'
  },
  CreateOrder: {
    neworder: '新订单',
    pointOut: '此功能用于将您的虚拟货币兑换为现实货币。当前可兑换的货币为USD。请按下以下按钮，并输入必要的信息以完成订单申请。',
    createbutton: '创建新订单'
  },
  orderList: {
    titleList: '订单列表',
    textList: '可以阅览已申请和正在申请的订单。',
    listbutton: '显示订单列表'
  },
  /**
     * OrderCreate
     */
  OrderCreate: {
    OrderCreate: '创建新订单',
    Terms: '确认条款',
    Input: '输入信息',
    Confrim: '信息确认',
    Complete: '完成',
    text: '通过填入以下信息以申请新的订单。页面显示的兑换汇率为参考汇率，并非最终汇率。实际汇率请以运营商通知为准。'
  },
  /**
     * OrderCreate-Terms
     */
  OrderTerms: {
    TermsTitle: 'SCALES Terms of Service',
    confirmed: '同意上述服务条款',
    BackButton: '返回',
    NextButton: '确认',
    CreateButton: '申請'
  },
  /**
    * OrderCreate-Currency
    */
  OrderCurrency: {
    amountOfCurrency: '虚拟货币',
    amountOfCurrencyTips: '请输入货币总额',
    BTC: 'BTC',
    referenceExchangeRate: '参考汇率',
    referenceExchangeRateTips: '此处显示的汇率为参考汇率，可能会与实际兑换时的汇率不一致。实行兑换时的汇率可能会与当前参考汇率有较大出入，请知悉。',
    budgetEstimate: '预计金额',
    budgetEstimateTips: '根据参考汇率计算得到的兑换金额。与参考汇率一样，实行兑换时金额可能会与当前预计金额有较大出入，请知悉。',
    serviceCharge: '手续费',
    serviceChargeTips: '使用本服务所产生的手续费。',
    traded: '无法受理超过100万USD的订单。请将预计金额控制在100万USD以内提交申请。'
  },
  /**
     * TwiceVerification
     */
  TwiceVerification: {
    modalSubmit: '发送',
    verificationCodeExplainLogin: '请输入MFA code完成登录。',
    verificationCodeExplainOrder: '请输入MFA code以完成验证。',
    verificationCodeExplainInfo: '请输入MFA code以完成验证。',
    twiceVerification: 'MFA 验证',
    verificationCode: 'MFA Code：',
    verificationCodePlaceholder: '请输入验证码',
    verificationCodeRequired: '请输入验证码',
    bindAuthenticator: '绑定虚拟MFA设备',
    SetVerificationCodeStep1: '将虚拟MFA APP安装到手机',
    SetVerificationCodeStep2: '使用虚拟MFA APP并打开摄像头扫描屏幕上的二维码',
    UrlCopy: '或者在APP上输入密钥。',
    SetVerificationCodeStep3: '请下下方输入MFA Code',
    Copy: '点击复制',
    CopySuccess: '已复制'
  },
  /**
     * OrderApplication completed
     */
  ApplicationCompleted: {
    Applicationcompleted: '已创建新的订单申请。',
    pointOut: '感谢您提交的订单申请。已将虚拟货币的转账地址发送至您所绑定的邮箱。请确认邮箱内容并将虚拟货币转至指定账户。转账完整后请将转账证明（截图和TXID）填写至订单信息并提交审核。',
    ReturnButton: '返回订单列表'
  },
  /**
     * OrderListTOP
     */
  OrderListTop: {
    OrderList: '订单列表'
  },
  /**
     * OrderList SearchBar
     */
  SearchColumn: {
    NO: '订单号码',
    Status: '申请状态',
    All: '全部',
    search: '搜索'
  },
  /**
     * All
     */
  AllSearchBar: {
    AC: '订单已申请',
    GU: '客户已放弃',
    WC: '正在确认货币到账',
    C: '管理员已取消',
    RA: '已确认货币到账',
    CR: '汇率确定',
    PC: '已完成订单'
  },
  /**
     * orderList page
     */
  orderlist: {
    AppInfo: '订单信息',
    Transaction: '虚拟货币转账信息',
    CoinPS: '货币转账地址',
    CoinA: '货币额',
    CoinTXID: '转账TXID',
    TXIDTips: 'TXID为比特币转账时产生的交易ID。请从交易结果界面将交易ID复制到此处。',
    Evidence: '转账证明（图片）',
    Category: '兑换账户',
    isFairFX: '第二账号',
    notFairFx: '第二账号以外',
    FairFXnum: '第二账号号码',
    FairFXnumTipe: '请输入第二账号号码',
    ExchangeRI: '兑换汇率信息',
    ConfirmCopperRate: 'Determined Copper Rate',
    ConfirmEdexchangeRate: '确定汇率信息',
    ConfirmedAmount: '确定兑换金额',
    ServiceCharge: '手续费',
    ExchangeRIR: '兑换汇率信息（申请时）',
    ConfirmEdexchangeRateR: '参考汇率',
    ConfirmedAmountR: '预计金额',
    ServiceChargeR: '手续费',
    JP: '日本',
    CN: '中国',
    ContactMatters: '消息',
    Operatormessage: '客服消息',
    Usermessage: '用户消息',
    USD: 'USD',
    Savebtn: '保存',
    Giveup: '放弃订单',
    Request: '提交转账信息审核',
    userInfo: '用户信息',
    name: '姓名',
    email: '邮箱地址',
    tel: '电话号码',
    copperRateRequired: 'Please input the Determined Copper Rate',
    newRateRequired: '请输入确定转换汇率',
    mailLanguage: '邮件接收语言',
    limit: '最多能够显示1000条数据。',
    lower: '确定汇率低于参考汇率的90%，请于上级沟通后确认汇率。',
    before: '变更前',
    after: '变更后',
    ImgUpload: '上传图片'
  },
  OListinfoxin: {
    fairFX: '第二账号',
    accountHolderNameTips: '请输入账户持有人姓名',
    myResidenceTips: '请输入您的住所',
    mycityTips: '请输入您所在的城市',
    myPostalCodeTips: '请输入您所在地区的邮政编码',
    accountNumberTips: '请输入银行账户',
    bankName: '请输入开户银行名称',
    bankStreet: '请输入开户银行地址',
    bankCity: '请输入开户银行所在城市',
    firstName: '请输入First Name',
    lastName: '请输入Last Name',
    bankPostcode: '请输入开户银行所在地邮政编码',
    bankSWIFT: '请输入开户银行SWIFT号码'
  },
  /**
     * orderListPopupseven page
     */
  orderListPopup: {
    Confirm: '确认',
    Tips: '将保存申请信息，请确认无误。',
    Tipsgiup: '将要放弃本次订单申请，请确认无误。',
    Tipsrequ: '将上传转账TXID和转账证明，请确认无误。',
    UserMessage: '用户消息',
    savesuccessful: '已保存申请信息。',
    retrunorderList: '返回订单列表',
    change: '已更新申请状态',
    Messgae: '消息',
    uploadFileOut: '无法上传图片,请将图片大小控制在 5MB 以内',
    uploadFileTypeWrong: '上传失败,请上传图片类型',
    Evidence: '转账证明',
    EvidenceTips: `You can check <a href="${ENV.EVIDENCE}" target="_blank">here</a> to confirm the sample screen capture.`,
    EvidenceIntr: `Please take a screenshot of Transaction ID <br />
    on the following page <br />
    (<a href="https://www.blockchain.com/explorer" target="_blank">https://www.blockchain.com/explorer</a>)`
  },
  /**
     * OrderList DisplayBar
     */
  DisplayBar: {
    Application: '申请时间',
    UpdateTime: '更新时间',
    filter: '过滤',
    PreviousButton: '上一页',
    NextButton: '下一页',
    FirstButton: '首页',
    LastButton: '尾页'
  },
  /**
     * SettingsPage
     */
  Settingspage: {
    SettingsTop: '设置',
    UpdateInfo: '用户信息变更',
    Tips: '对用户的基本信息、银行信息、邮箱接收语言等进行变更。',
    UpdateButton: '变更',
    UpdatePassword: '登录密码修改',
    UpdatePsdTips: '修改登录时所使用的密码。',
    UpdateTwofactauth: '二次验证信息变更',
    UpdateTwofactauthTips: '变更认证APP、手机丢失更改绑定手机设备。'
  },
  /**
     * SettingUpdateInfoPage
     */
  UpdateInfoTop: {
    UpdateInfo: '用户信息变更',
    Input: '信息输入',
    Confirm: '信息确认',
    Complete: '完成',
    text: '对用户的基本信息、银行信息、邮箱接收语言等进行变更。'
  },
  /**
    *  Setting UpdateInfoPage Form
    */
  UpdateInfoForm: {
    UserInforTitle: '基本信息',
    MyName: '姓名',
    MyNameTips: '请输入您的姓名',
    MyTelephone: '电话号码',
    TelephoneTips: '请输入您的电话号码',
    TelephoneTips1: '请输入正确的电话号码',
    language: '邮箱接收语言',
    FairFX: '第二账号账户信息',
    FairFXNumber: '第二账号号码',
    BankAccount: '银行账户信息',
    accountHolderName: '持有人姓名',
    accountHolderNameTips: '请输入银行账户持有人姓名',
    myResidence: '住所',
    mycity: '所在城市',
    myPostalCode: '所在地邮政编码',
    mycountry: '所在国家',
    IBAN: 'User Address',
    accountNumber: '银行账户号码',
    bankName: '银行名称',
    bankStreet: '银行地址',
    bankCity: '银行所在城市',
    bankPostcode: '银行所在地邮政编码',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankCountry: '银行所在国家',
    bankSWIFT: '银行SWIFT号码',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    Backbtn: '返回',
    Confirmbtn: '确认',
    Changebtn: '变更'
  },
  /**
     * UpdateInfo Complete Page
     */
  UpdateComplete: {
    Complete: '用户信息变更成功。',
    ReturnSettings: '返回设置界面'
  },
  /**
     * Update password Page
     */
  UpdatePasswordPage: {
    UpdatePassword: '密码修改',
    Tips: '修改登录时所使用的密码。',
    CurrentPassword: '当前密码',
    ErrorPormpt: '请输入当前密码',
    NewsPassword: '新密码',
    ErrorPormptnewspad: '请输入新密码',
    VerifyPassword: '再次输入新密码',
    ErrorPormptVerify: '请再次输入新密码',
    notMatch: '两次输入密码不一致',
    Cancelbtn: '取消',
    Changebtn: '修改',
    Updatesucceeded: '密码修改完成'
  },
  RegisterPage: {
    Terms: '使用条款',
    Input: '输入信息',
    Confrim: '信息确认',
    Complete: '完成',
    center: 'SCALES Terms of Service',
    Confirm: '同意使用条款内容。',
    Next: '下一步'
  },
  Registerform: {
    UserInforTitle: '用户信息',
    Email: '邮箱地址',
    MyName: '姓名',
    MyNameTips: '请输入您的姓名',
    MyTelephone: '电话号码',
    TelephoneTips: '请输入您的电话号码',
    TelephoneTips1: '请输入正确的电话号码',
    language: '邮箱接收语言',
    FairFX: '第二账号账户信息',
    FairFXNumber: '第二账号号码',
    BankAccount: '银行账户信息',
    accountHolderName: '持有人姓名',
    accountHolderNameTips: '请输入银行账户持有人姓名',
    myResidence: '住所',
    mycity: '所在城市',
    myPostalCode: '所在地邮政编码',
    mycountry: '所在国家',
    IBAN: 'User Address',
    accountNumber: '银行账户号码',
    bankName: '银行名称',
    bankStreet: '银行地址',
    bankCity: '银行所在城市',
    bankPostcode: '银行所在地邮政编码',
    firstName: 'First Name',
    lastName: 'Last Name',
    bankCountry: '银行所在国家',
    bankSWIFT: '银行SWIFT号码',
    routing: 'Routing',
    BACS: 'BACS/SEPA',
    successful: '账号注册完成。',
    logininterface: '点击下面按钮，返回登录界面。',
    Login: '登录',
    Backbtn: '返回',
    Confirmbtn: '确认',
    Changebtn: '变更',
    Regist: '注册'
  },
  languageChoice: {
    English: 'English',
    Japanese: '日本語',
    Chinese: '中文(简体)'
  },
  LandingForm: {
    Email: '邮箱地址',
    Emailplaceholder: '请输入您的邮箱地址',
    emailTips: '请输入您的邮箱地址',
    Password: '密码',
    Passwordplaceholder: '请输入您的密码',
    PasswordTips: '请输入您的密码',
    Repeatpassword: '再次输入密码',
    Repeatpsdplaceholder: '请再次输入您的密码',
    RepeatpsdTips: '请再次输入您的密码',
    PsdAndPassword: '两次输入的密码不一致',
    Signup: '注册',
    SigninLeft: '已注册账号？ ',
    Signin: '点击登录',
    TwitterLink: ENV.TWITTER_LINK
  },
  Landing: {
    Scales: 'Scales',
    text1: 'Why increase the',
    text2: 'useless plastic?',
    text3: 'Taking lessons from history <br/> Innovating the Future',
    text4: 'Sustainable Exchange Service',
    tryToService: 'Try the Service'
  },
  LandingCentertext1: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Sustainable Exchange Service (SES) provided by Scales, provides you a high-level privacy protective crypt currency account.',
    Sustainable: 'Sustainable',
    WhereverText: 'By using Sustainable Exchange Service (SES), you can have a trusted account which is protected from country risk.',
    Secure: 'Secure',
    WheneverText: 'Scales is cooperating with British big bank and financial provider to give you the ability to manage your assets.',
    Convenience: 'Convenience',
    WhoeverText: 'According to your purpose, you can choose appropriate way to manage your assets. Every operation only needs a few clicks.'
  },
  LandingCentertext2: {
    textTop1: 'Commonly called Crypt <br/> Currency Card',
    textTop2: 'To use exist services, you usually need a complicated procedure such as purchase cards, sign up for the application, install the application, and an expensive initial cost. Besides, services might be terminated unexpectedly because of the change of country regulations. Also, accounts might become unavailable when service card is expired in a few years.'
  },
  LandingCentertext3: {
    textTop1: 'Sustainable Exchange <br/> Service (SES)',
    textTop2: 'Regarding our service, you can sign up only by a few clicks. Your assets is protected in trusted banks so you do not need to worry whether the account is safe, whether the service is available, etc. You can also transfer your currency to any bank account all over the world. Besides, even if the debit card issued by the bank become available, it do nothing to the account. Your whole assets will be 360-degree protected.',
    text1: 'EXCHANGE',
    text2: 'TRANSFER',
    text3: 'Or',
    text4: 'Secure Foreign Account <br/> ※Not Subject to CRS'
  },
  LandingCentertext4: {
    textTop1: 'Secure',
    textTop2: 'Scales is cooperating with British big bank and financial provider to give you the ability to manage your assets.'
  },
  LandingCentertext5: {
    textTop1: 'Convenience',
    textTop2: 'You can start the service by just signing up with your e-mail address. You are only asked to submit the KYC according to your transaction amount. Also, we provide several ways to manage your assets.'
  },
  LandingCentertext6: {
    textTop1: 'Method 1 (Easy to Start)',
    textTop2: 'Exchange your currency to your own bank',
    textTop3: 'Method 2 (Recommended)',
    textTop4: 'Exchange your currency to your PayGlobal Account',
    text1: 'Easy <br/> Start',
    text2: 'Create an account',
    text3: 'Exchange',
    text4: 'Please tell me your bank <br/> account information.',
    text5: 'Receive cash',
    text6: 'SUBACCOUNT',
    step1: 'STEP ONE',
    step2: 'STEP TWO',
    step3: 'STEP THREE',
    step4: 'STEP FOUR'
  },
  LandingBottom1: {
    Title: 'Who we are',
    Title2: 'working with',
    TitleTips: 'We cooperate with highly trusted bank and financial providers. So you do not need to worry anything about your assets.'
  },
  registSuccess: {
    Title: '感谢您的注册使用。',
    TitleTips: '已将确认邮件发送至您的邮箱。确认邮件内容后请点击邮件提供的链接以完成账号注册。',
    OK: 'OK'
  },
  ClientMessage: {
    timeout: '请求超时。',
    Request: '请求错误。',
    title: '消息',
    Retrybtn: '重试',
    Cancelbtn: '取消',
    OKbtn: 'OK',
    page404: '找不到页面。',
    page500: '发生内部错误。',
    Undefinederroe: '未定义的错误代码：',
    page1001: '参数检测错误。',
    page1002: '登录失败。',
    page1003: '非法访问，请先登录。',
    page1004: '处理失败。',
    page1005: '文件上传失败。',
    page1006: '非法访问，请先登录。',
    page1007: '登录超时。请再次登录。',
    page9001: '发生内部错误。',
    page9002: '发生未知错误。(9002)',
    Unknownerror: '发生未知错误。',
    login: '登录'
  },
  privacyPolicy: {
    registerPrivacyPolicy: privacyPolicyZH
  }
}



// WEBPACK FOOTER //
// ./src/scripts/consts/i18n/zh.js